export const blockIconsBusinessandpaymentsCalculateNew = (
	<span className='material-symbols-outlined'>calculate</span>
);
